import React, { useState, useEffect } from "react";
import { useLoadScript, Autocomplete } from "@react-google-maps/api";

const libraries = ["places"];

const MapComponent = ({ onLocationSelect, initialAddress }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyB4D0HM4FufPLxwOFLQbI2-MsHA09yAnAs",
    libraries,
  });

  const [autocomplete, setAutocomplete] = useState(null);
  const [inputText, setInputText] = useState("");
  const [selectedAddress, setSelectedAddress] = useState(initialAddress);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    // Initialize the address from the props if it's not already set
    if (!inputText) {
      setInputText(initialAddress);
    }
    setSelectedAddress(initialAddress);
  }, [initialAddress]);

  const onPlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      
      if (place && place.geometry && place.geometry.location) {
        const location = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };

        const address = place.formatted_address;

        onLocationSelect({
          lat: location.lat,
          lng: location.lng,
          address,
        });

        // Only update inputText if place is valid and selected from the dropdown
        setInputText(address);
        setSelectedAddress(address);
        
        setIsPopupOpen(false); // Close the popup after selecting a place
      } else {
        alert("Please select a valid location from the dropdown.");
      }
    }
  };

  useEffect(() => {
    document.body.style.overflow = isPopupOpen ? "hidden" : "unset";
  }, [isPopupOpen]);

  if (loadError) {
    return <p>Error loading map</p>;
  }

  return (
    <div className="flex justify-center items-center">
      <div
        className="text-[#9CA3AF] gap-2 flex font-semibold cursor-pointer text-[12px] md:text-[16px]"
        onClick={() => setIsPopupOpen(true)}
      >
        <span className="material-symbols-outlined text-[#11485B] !text-[20px] mt-">
          location_on
        </span>
        <p>
          {selectedAddress
            ? selectedAddress.split(" ").slice(0, 4).join(" ") + (selectedAddress.split(" ").length > 10 ? "..." : "")
            : "Click to select location"}
        </p>
      </div>

      {isPopupOpen && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-3 rounded-xl shadow-lg w-[300px] h-[170px] animate__animated animate__bounceIn">
            <p className="flex justify-end cursor-pointer">
              <span
                onClick={() => setIsPopupOpen(false)}
                className="material-symbols-outlined !font-semibold !text-[18px] text-[#222222] hover:text-[#27648B] p-2"
              >
                close
              </span>
            </p>
            {isLoaded ? (
              <Autocomplete
                onLoad={(autocompleteInstance) => setAutocomplete(autocompleteInstance)}
                onPlaceChanged={onPlaceChanged}  // Call onPlaceChanged directly when the place changes
              >
                <div className="mt-2 flex flex-col">
                  <input
                    type="text"
                    className="w-full border text-[#9CA3AF] font-semibold border-[#C9C9C9] p-2 rounded-xl placeholder-[#9CA3AF]"
                    placeholder="Search location..."
                    value={inputText}  // Binding inputText to the input field
                    onChange={(e) => setInputText(e.target.value)}  // Allow manual typing
                  />
                  <div className="flex gap-3">
                    <button
                      onClick={onPlaceChanged}  // Update place when the user selects from the suggestions
                      className="mt-3 px-4 py-2 bg-[#27648B] w-[140px] hover:bg-[#27648B] text-white rounded-lg"
                    >
                      Set Location
                    </button>
                    <button
                      onClick={() => setIsPopupOpen(false)}
                      className="mt-3 text-[#27648B] px-4 py-2 w-[120px] border rounded-lg border--[#C9C9C9] hover:bg-[#ffff]"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Autocomplete>
            ) : (
              <p>Loading map...</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MapComponent;
